import React from "react";

import "./styles.less";
import { useTranslation } from "react-i18next";
import { Title } from "../../components/Title";

export const DatabaseAdvantage = () => {
  const { t } = useTranslation();
  const advantageList = [
    t("learn.database.advantage.list1"),
    t("learn.database.advantage.list2"),
    t("learn.database.advantage.list3"),
    t("learn.database.advantage.list4"),
  ];
  return (
    <section>
      <div className="database-advantage">
        <div className="inner">
          <div className="content">
            <Title title={t("learn.database.advantage.title")}></Title>
            <div className="advantage-warp">
              <div className="advantage-description">
                {advantageList.map((item) => (
                  <div className="list">
                    <i className="icon authing-icon authing-d" style={{ color: "#396aff", marginRight: 8 }}></i>
                    <span>{item}</span>
                  </div>
                ))}
              </div>
              <div className="advantage-img">
                <img src="//files.authing.co/authing-website/product-database-advantage.png" alt="authing advantage" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
